import MidiPlayer from 'midi-player-js'

$(".grey-heart").click(function (e) {
    e.preventDefault()
    e.stopPropagation()
    $(this).toggleClass("red-heart");
})

//BURGER MENU FRONT

let studentMenuOpen = false;

$(".burger-menu").click((e) => {
    $("#mySidenav").fadeIn(300);
});

$(".front-sidenav-close").click((e) => {
    $("#mySidenav").fadeOut(300);
});

$(".burger-menu-student").click((e) => {
    let menu = $("#mySidenav-student");

    if (!studentMenuOpen) {

        menu.fadeIn(300);
        $('.right-dashboard').css({
            'position': 'fixed',
        });
        $('.overlay').show();
        $(".burger-menu-student").css({
            position: 'absolute',
            zIndex: 999,
            left: '250px',
            top: 0,
            transition: "all ease 0.3s"
        });
    } else {

        menu.fadeOut(300);
        $('.right-dashboard').css({
            'position': 'relative',
        });
        $('.overlay').hide();
        $(".burger-menu-student").css({
            position: 'static',
            display: "block"
        });
    }

    studentMenuOpen = !studentMenuOpen;
});

$(".close-btn-student").click((e) => {
    let menu = $("#mySidenav-student");
    menu.fadeOut(300);
    $('.right-dashboard').css({
        'position': 'relative',
    });
    $('.overlay').hide();
    $(".burger-menu-student").css({
        position: 'static',
        display: "block"
    });

    studentMenuOpen = false;
});

$(document).on('click', '.about-course', function (e) {
    if ($(this).find('a.green-btn').length) {
        var href = $(this).find('a.green-btn').attr('href');
        if ("ontouchstart" in document.documentElement) {
            document.location.href = href;
        }
    }
})

$(document).ready(function () {
    // Initialize player and register event handler
    var notes = [71, 76, 64, 79, 78, 83, 81, 75, 70, 59, 77, 67, 74, 85, 60, 72, 65, 84, 68, 80, 69, 45, 44, 82, 61, 66, 90, 62];
    notes.sort();

    function swap(json) {
        var ret = {};
        for (var key in json) {
            ret[json[key]] = key * 1;
        }
        return ret;
    }

    var final_notes = swap(notes);
    var Player = new MidiPlayer.Player(function (event) {
        if (typeof event.noteNumber === 'undefined') {
            return;
        }
        var sel = Math.floor(final_notes[event.noteNumber] / 2);
        if (sel == 0) {
            sel = 1;
        }
        var el = $('.building-footer').find('svg > g > g:nth-child(' + sel + ')');
        if (event.name == 'Note on') {
            el.attr('class', 'hover');
        } else {
            el.attr('class', '');
        }
    });

// Load a MIDI file
    window.song = 'data:audio/midi;base64,TVRoZAAAAAYAAAABAeBNVHJrAAAFWgD/IAEAAP8DCHRtYyAoMSlpAP8EFFN0ZWlud2F5IEdyYW5kIFBpYW5vAP9YBAQCGAgA/1kCAAAA/1QFIAAAAAAA/1EDB6EgAMAAAJBHI4JOkEwpFZBAFoIagEdAgRKATEAfkE8egRKAT0AAkE4aNJBPDx+AT0A1gEBAcoBOQCCQTCkKkEAhg0GATEBekFMjggWAU0BTkFEqgniAUUCDf4BAQACQTiQVkEAWgmOATkCCOYBAQIE8kEAkAEwqg1WATEALkE8hgQeQTicLgE9AghmQSy4LkEYhCoBAQAuATkCDVYBLQFSQOx0ATS4KgEZAgkSQRyYVkEAkaIA7QD+ATUCDDJBDJIVQgENAKoBAQIESkDscgi6QQC4ATDKBCIA7QIFbgEdAgR2QTxRTgExAFZBOKguAT0CCLpBMLkmATkCDDYBMQHOQUySCD4BTQACQSjMKkEMrP4BAQACQRheDYIBGQF6QVRuBW4BDQAqASkAVgFVAAJA8HQBIIzSQQRsLkE0pCpBUNSqQRBmBZoBIQIExgFRAXpBQLRWQVAmBB4BEQHOAPEAAQUALkDwgCoBUQAqATUALkEwtFZBAIQBFIhWQLRkVkFQ0FIAtQABQQDWQLA8fgCxAgRKARUAqgFRAcpBTJQuATEBzkFIdCoBTQCqQUxFTgFNAXoA8QCqAUkAqgEBAAJA9KgBSHwqQRjALkEAhNIBAQACQQiRTgEJAC5BAIABCJBWAQEAAQkA0kEAfAEIjFYBAQABCQAqQQiUqkEAdFYBAQABCQAqQQiELgFJACpBAHQqAQkAggEBAH5BAGSqAQEAfkEAXP5BPJwqAQEALkEAmgQeARkCBMpBMMhSAPUAAT0CEH4BMQBWQQySCWJBHH4IkgEBAC4BDQIIFkE8jCpA7HEmAR0CCBZBTIwuAT0AAkEAmaIA7QCqAU0AfkFMQaIBTQIIQkEMngk2QUyQLkEcfgVGAU0CBMYBDQIESgEBAC5A7HgBPHn2AR0B9gE9AXpBUMgqQQChzgDtAgTyAVECBcJBDKABTJoIagFNAKZBIJABSKoMCgEhAgROAQ0AfgEBAAFJACpBOLAuQOyOCToBOQACQTykVkEAnH4A7QAqQOxBJgDtAghCAT0AfkFMbfYBTQACQUiMLkEMcghmAUkA0kDwlC4BAQAqAQ0AAkEYphBWARkAAkEcqCpBDIzSQWgo0gFpAgUeQUywUgDxAAJBAJiqAQ0CBcIBTQDSAR0BpkFMKfYBTQAqQQyKCRJBHHIIagENAgjmQTx4UgEBAC5A7FnOAR0CBPIBPQACQUyUfkEAcPoA7QIE8gFNAgi+QQymCTpBHGwqQUyM/gEBAgUaAU0CBEoBDQH2QQysVgEdAC5BHCSmAR0CBZpA+GwBKMCqAQ0AKkEMsAEYlgRKAPkCDApBVHlSARkBTgENAFYBKQD+AVUAVkEgnCpA8Gh+QQSEVkE0mFZBEIxWAPEAAkFQ5FZA8EYIPgEhAAFRAgVuQUCx+kFQNNIA8QABNQAqAQUBJgERAFZBHEyqQQCMATDMVgFRACoBQQACQOxUAQyMqkFQ1gjmAVEBTkFMjaYBHQAqAU0AAkFItAFQLC4BMQACQUxIpgFNANIBDQIFmkEMNAEYuCoA7QABAQAuQPSgKgENAAFRAC5BAIxWAQEAfkEIgCoBSQAuAQkAKkEImIIBCQAqQQCQAQiMVgEBAAEJANJBAJQBCJBWAQEAAQkAfkEAiFZBCIRWAQEAAQkAfkEAhgVuQTyF+gEZAgVuAT0AAkEwvFYA9QINAgExAfpBDI4JDkEcXFYBAQIIugENAgR2AR0AA/y8A';
    Player.loadDataUri(window.song);
    window.song_is_playing = false;

    function display_message(mes) {
        Player.play();
        window.song_is_playing = true;
        Player.on('endOfFile', function () {
            $('.building-footer').find('svg > g > g.hover').attr('class', '');
            window.song_is_playing = false;
        });
    }

    $(document).on('click', '[data-tmcpartmidi-start]', function () {
        MIDIjs.message_callback = display_message;
        if (!window.song_is_playing) {
            MIDIjs.play('/tmcpart.midi');
        }
    });
});

$(document).ready(function () {
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    let mobile_input = document.querySelector('#mobile_number_got_questions_form')
    let iti;
    if (mobile_input) {
        iti = window.intlTelInput(mobile_input, {
            preferredCountries: ['ae', 'in', 'ru', 'de'],
            separateDialCode: true,
            customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                return "e.g. " + selectedCountryPlaceholder;
            },
        });
    }
    const early_bird_popup = document.getElementById('got_questions_popup');
    const closeButton = document.getElementById('gotQuestionsCloseButton');

    if (closeButton) {
        closeButton.addEventListener('click', (e) => {
            early_bird_popup.style.display = 'none';
            setCookie('got_questions_popup_closed', 1, 3);
        });
    }

    if (!getCookie('got_questions_popup_closed') && !$('body').hasClass('course-bootcamp')) {
        setTimeout(function () {
            $('#got_questions_popup').fadeIn();
        }, 5000);
    }

    $(document).on('submit', '#got_questions_form', function (e) {
        e.preventDefault();
        var form = $(this)[0];
        var form_url = $(this).attr('action');
        var formArray = {};
        let mobile_prefix = '';
        if (typeof iti !== 'undefined') {
            mobile_prefix = iti.getSelectedCountryData().dialCode;
        }
        var val = '';

        for (var i = 0; i < form.length; i += 1) {
            val = form[i].value;
            if (form[i].name == 'phone') {
                val = '+' + mobile_prefix + val;
            }
            formArray[form[i].name] = val;
        }

        $(this).hide();
        $("#got-questions-form-area .send-suggestion-spinner").show();
        $('#got_questions_form .errors_area').html('').hide();

        axios.post(form_url, formArray).then(({data}) => {
            let current_fs, next_fs
            let left, opacity, scale;

            current_fs = $('fieldset#got-questions-form-area').hide()
            next_fs = current_fs.next();

            next_fs.show();
            current_fs.animate({opacity: 0}, {
                step: function (now) {
                    scale = 0.8 + (1 - now) * 0.2;
                    left = ((1 - now) * 50) + "%";
                    opacity = 1 - now;
                    current_fs.css({'left': left});
                    next_fs.css({'transform': 'scale(' + scale + ')', 'opacity': opacity});
                },
                duration: 400
            });
            setCookie('got_questions_popup_closed', 1, 3);

            setTimeout(function () {
                $('#got_questions_popup').fadeOut();
            }, 6000);
        })
            .catch(function (error) {
                if (error.response) {
                    var errors = [];
                    for (i in error.response.data.errors) {
                        let j;
                        for (j in error.response.data.errors[i]) {
                            errors.push(error.response.data.errors[i][j]);
                        }
                    }
                    $('#got_questions_form').show();
                    $('#got_questions_form .errors_area').html("<p>" + errors.join('<br />') + "</p>").show();
                    $('#got-questions-form-area .send-suggestion-spinner').hide();
                    $('fieldset#got-questions-form-area').next().hide();
                }
            })
    })

    let mobile_input2 = document.querySelector('#mobile_callback')
    let iti2;
    if (mobile_input2) {
        iti2 = window.intlTelInput(mobile_input2, {
            preferredCountries: ['ae', 'in', 'ru', 'de'],
            separateDialCode: true,
            customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
                return "e.g. " + selectedCountryPlaceholder;
            },
        });
    }

    $(document).on('submit', '#request-callback', function (e) {
        e.preventDefault();

        let firstName = $('#firstName').val();
        let lastName = $('#lastName').val();
        let fullName = firstName + ' ' + lastName;

        $('#fullName').val(fullName);


        var form = $(this)[0];
        var form_url = $(this).attr('action');
        var formArray = {};
        let mobile_prefix = '';
        if (typeof iti2 !== 'undefined') {
            mobile_prefix = iti2.getSelectedCountryData().dialCode;
        }
        var val = '';

        for (var i = 0; i < form.length; i += 1) {
            val = form[i].value;
            if (form[i].name == 'phone') {
                val = '+' + mobile_prefix + val;
            }
            formArray[form[i].name] = val;
        }


        $(this).hide();
        $("#contact_request_back_form .send-suggestion-spinner").show();
        $('#request-callback .errors_area').html('').hide();

        axios.post(form_url, formArray).then(({data}) => {
            let current_fs, next_fs
            let left, opacity, scale;

            current_fs = $('fieldset#contact_request_back_form').hide()
            next_fs = current_fs.next();

            next_fs.show();
            current_fs.animate({opacity: 0}, {
                step: function (now) {
                    scale = 0.8 + (1 - now) * 0.2;
                    left = ((1 - now) * 50) + "%";
                    opacity = 1 - now;
                    current_fs.css({'left': left});
                    next_fs.css({'transform': 'scale(' + scale + ')', 'opacity': opacity});
                },
                duration: 400
            });

            setTimeout(function () {
                $('.request-callback').fadeOut();
            }, 6000);
        })
            .catch(function (error) {
                if (error.response) {
                    var errors = [];
                    for (i in error.response.data.errors) {
                        let j;
                        for (j in error.response.data.errors[i]) {
                            errors.push(error.response.data.errors[i][j]);
                        }
                    }
                    $('#request-callback').show();
                    $('#request-callback .errors_area').html("<p>" + errors.join('<br />') + "</p>").show();
                    $('#contact_request_back_form .send-suggestion-spinner').hide();
                    $('fieldset#contact_request_back_form').next().hide();
                }
            })
    })
});

document.addEventListener('DOMContentLoaded', function () {
    // Selectează toate elementele cu clasa 'hover-anim-1'
    const hoverContainers = document.querySelectorAll('.hover-anim-1');

    hoverContainers.forEach(function (hoverContainer) {
        // Creează un element div pentru a conține SVG-ul
        const arrowDiv = document.createElement('div');
        arrowDiv.classList.add('arrow');

        // Adaugă SVG-ul în elementul creat
        arrowDiv.innerHTML = `
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="fi-rr-angle-small-right">
                    <path id="Vector" d="M12.8336 8.23408L9.0086 4.40908C8.85246 4.25387 8.64125 4.16675 8.4211 4.16675C8.20094 4.16675 7.98973 4.25387 7.8336 4.40908C7.75549 4.48654 7.69349 4.57871 7.65119 4.68026C7.60888 4.78181 7.5871 4.89073 7.5871 5.00074C7.5871 5.11075 7.60888 5.21967 7.65119 5.32122C7.69349 5.42277 7.75549 5.51494 7.8336 5.59241L11.6669 9.40908C11.745 9.48654 11.807 9.57871 11.8493 9.68026C11.8916 9.78181 11.9134 9.89073 11.9134 10.0007C11.9134 10.1108 11.8916 10.2197 11.8493 10.3212C11.807 10.4228 11.745 10.5149 11.6669 10.5924L7.8336 14.4091C7.67668 14.5649 7.58808 14.7767 7.5873 14.9978C7.58652 15.2189 7.67362 15.4313 7.82943 15.5882C7.98524 15.7452 8.19701 15.8338 8.41815 15.8345C8.63929 15.8353 8.85168 15.7482 9.0086 15.5924L12.8336 11.7674C13.3018 11.2987 13.5647 10.6632 13.5647 10.0007C13.5647 9.33824 13.3018 8.70283 12.8336 8.23408Z" fill="#171717"/>
                </g>
            </svg>
        `;

        hoverContainer.appendChild(arrowDiv);


    });
});
